import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import {globalPersistReducer} from "@/store/slices/globaleSlice";
import {localPersistReducer} from "@/store/slices/localeSlice";
import {tempPersistReducer} from "@/store/slices/tempSlice";
import userRolesReducer from "@/store/slices/userRolesReducer";

const rootReducer = combineReducers({
    global: globalPersistReducer,
    local: localPersistReducer,
    temp: tempPersistReducer,
    userRoles: userRolesReducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;